"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useBurgerMenu = exports.burgerMenuContextDefaultValue = exports.burgerMenuContext = exports.BurgerMenuProvider = void 0;
var ToggleMenuFlyout = _interopRequireWildcard(require("@ori-events/toggle-menu-flyout"));
var _react = require("react");
var _api = require("../../api");
var _useIsMobile = require("../../hooks/useIsMobile");
var _activeMenuContext = require("./activeMenuContext");
var _jsxRuntime = require("react/jsx-runtime");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
// istanbul ignore file -- api

const burgerMenuContextDefaultValue = exports.burgerMenuContextDefaultValue = {
  aboutItems: [],
  loadingAboutItems: false,
  inspirationItems: [],
  loadingInspirationItems: false,
  shopSectionItems: [],
  loadingShopSectionItems: false
};
const burgerMenuContext = exports.burgerMenuContext = /*#__PURE__*/(0, _react.createContext)(burgerMenuContextDefaultValue);
const BurgerMenuProvider = ({
  children
}) => {
  const {
    activeMenu
  } = (0, _activeMenuContext.useActiveMenu)();
  const isMobile = (0, _useIsMobile.useIsMobile)();
  const isMenuActive = activeMenu === ToggleMenuFlyout.MenuTypes.BurgerMenu || isMobile && activeMenu === ToggleMenuFlyout.MenuTypes.AccountSideMenu;
  const {
    data: aboutItems,
    loading: loadingAboutItems
  } = (0, _api.useGetNavigationType)({
    type: 'AboutTiles',
    enabled: isMenuActive
  });
  const {
    data: inspirationItems,
    loading: loadingInspirationItems
  } = (0, _api.useGetNavigationType)({
    type: 'InspirationTiles',
    enabled: isMenuActive
  });
  const {
    data: shopSectionItems,
    loading: loadingShopSectionItems
  } = (0, _api.useGetNavigationType)({
    type: 'ShopSection',
    enabled: isMenuActive
  });
  const contextValue = (0, _react.useMemo)(() => ({
    aboutItems,
    loadingAboutItems,
    inspirationItems,
    loadingInspirationItems,
    shopSectionItems,
    loadingShopSectionItems
  }), [aboutItems, loadingAboutItems, inspirationItems, loadingInspirationItems, shopSectionItems, loadingShopSectionItems]);
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(burgerMenuContext.Provider, {
    value: contextValue,
    children: children
  });
};
exports.BurgerMenuProvider = BurgerMenuProvider;
const useBurgerMenu = () => (0, _react.useContext)(burgerMenuContext);
exports.useBurgerMenu = useBurgerMenu;
